import {useCallback} from 'react';

import {SIGN_IN_EVENTS} from '@/app/auth/events/SignInEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewSignIn = useCallback(() => {
    trackEvent(SIGN_IN_EVENTS.VIEW_SIGNIN, {
      project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
    });
  }, [trackEvent]);

  const trackSelectSignInContinue = useCallback(() => {
    trackEvent(SIGN_IN_EVENTS.SELECT_SIGNIN_CONTINUE, {
      project_tag: PROJECT_TAGS.ACCOUNT_ACCESS,
    });
  }, [trackEvent]);

  return {
    trackViewSignIn,
    trackSelectSignInContinue,
  };
};
